<!-- 字典查询 -->
<template>
  <div class='dicManagement'>
    <div class="search-form">
      <el-form
        inline
        :model="originData"
        ref="searchForm"
      >
      <el-form-item
        label="更新时间"
        prop="dictTypeName"
      >
        <el-date-picker type="date" v-model="originData.updateTimeStart" placeholder="起始日期" class="search-ipt upt-start"/>
        <b style="margin:auto 4px;">—</b>
        <el-date-picker type="date" v-model="originData.updateTimeEnd" placeholder="结束日期" class="search-ipt upt-end"/>
      </el-form-item>
      <el-form-item
        label="字典类别名称"
        prop="dictTypeName"
      >
        <el-input
          placeholder="请输入"
          v-model.trim="originData.dictTypeName"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="字典类别标识"
        prop="dictTypeCode"
      >
        <el-input
          placeholder="请输入"
          v-model.trim="originData.dictTypeCode"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="归属模块"
        prop="dictTypeName"
      >
        <yh-select-tree
          :width="200"
          :data="[{menuName: '(公用字典)',id:1}, ...menuData]"
          placeholder="请选择"
          :value="originData.menuName"
          @change="(data) => getNodeData('originData', data)"
          :render-content="renderSearchTreeItem"
        />
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click='search()'
        >查询</el-button>
        <el-button
          size="small"
          @click='rest()'
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addInfo()'
          v-if="functionList.indexOf(
          '322544803426045952')!='-1'"
        >新增字典类别</yh-button>
      </div>
    </div>
    <div class="user_table">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          label="字典类别ID"
          prop='id'
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.id}}
          </template>
        </el-table-column>
        <el-table-column
          label="字典类别名称"
          width="200"
        >
          <template slot-scope="scope">
            <span
              v-if="functionList.indexOf(
          '322545212274216960')!='-1'"
              class='productDecoration'
              @click='findDictDetail(scope.row)'
              v-html='scope.row.dictTypeName'
            >
            </span>
            <span
              v-else
              v-html='scope.row.dictTypeName'
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dictTypeCode"
          width="200"
          label="字典类别标识"
        >
        </el-table-column>
        <el-table-column
          width="300"
          prop="description"
          label="描述"
        >
        </el-table-column>
        <el-table-column
          width="100"
          prop="dicts"
          label="字典项个数"
        >
        </el-table-column>
        <el-table-column
          width="200"
          prop="menuName"
          label="归属模块"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.updateTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateUserid"
          label="修改人ID"
          width="200"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <span
                class="button--blue"
                @click="modify(scope.row)"
                type="primary"
                v-if="functionList.indexOf(
          '322544929796231168')!='-1'"
              >修改</span>
              <span
                class="button--blue"
                @click='findDictDetail(scope.row)'
                type="danger"
                v-if="functionList.indexOf(
          '322545212274216960')!='-1'"
              >查看字典项</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <!--新增-->
    <yh-dialog title="新增字典类别" :visible.sync="newdic">
      <el-form
        class="hide-error"
        :model="insertDictType"
        label-width="110px"
      >
        <el-form-item
          label="字典类别名称"
          prop="dictTypeName"
          required
        >
          <el-input
            v-model="insertDictType.dictTypeName"
            placeholder="请输入字典类别名称，不能超过20字"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别标识"
          prop="dictTypeCode"
          required
        >
          <el-input
            v-model="insertDictType.dictTypeCode"
            placeholder="请输入字典类别标识，不能超过40字"
            maxlength="40"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属菜单"
          prop="menuName"
          required
        >
          <yh-select-tree
            :width="320"
            :data="[{menuName: '(公用字典)',id:1}, ...menuData]"
            placeholder="请选择"
            :value="insertDictType.menuName"
            @change="(data) => getNodeData('insertDictType', data)"
            :render-content="renderSearchTreeItem"
          />
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
        >
          <el-input
            type="textarea"
            v-model="insertDictType.description"
            placeholder="请输入描述，不超过200字"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="newdic = false">取消</el-button>
        <yh-button
          type="primary"
          :loading="newAddLoadingFlag"
          @click="insertDictTypeClick()"
        >提交</yh-button>
      </span>

    </yh-dialog>
    <!--修改-->
    <yh-dialog title="修改字典类别" :visible.sync="modifyDic">
      <el-form
        class="hide-error"
        :model="updateDictType"
        label-width="110px"
      >
        <el-form-item
          label="字典类别名称"
          prop="dictTypeName"
          required
        >
          <el-input
            v-model="updateDictType.dictTypeName"
            placeholder="请输入字典类别名称，不能超过20字"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别标识"
          prop="dictTypeCode"
        >
          <el-input
            v-model="updateDictType.dictTypeCode"
            placeholder="请输入字典类别标识，不能超过40字"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属菜单"
          prop="menuName"
          required
        >
          <yh-select-tree
            :width="320"
            :data="[{menuName: '(公用字典)',id:1}, ...menuData]"
            placeholder="请选择"
            :value="updateDictType.menuName"
            @change="(data) => getNodeData('updateDictType', data)"
            :render-content="renderSearchTreeItem"
          />
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
        >
          <el-input
            type="textarea"
            maxlength="200"
            show-word-limit
            v-model="updateDictType.description"
            placeholder="请输入描述，不超过200字"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="modifyDic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="newUptLoadingFlag"
          @click="handleUpdateDictTypeClick()"
        >保存</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import { getFunctionList, addNav, getPagingData } from '@/mixins';

export default {
  name: 'DictionaryManagement',
  mixins: [getFunctionList, addNav, getPagingData],
  data() {
    return {
      emptyText: this.$LS.empty,
      // 初始数据
      originData: {
        dictTypeName: '',
        dictTypeCode: '',
        menuName: '',
        menuId: '',
        updateTimeStart: '',
        updateTimeEnd: '',
      },
      // 查询数据
      searchParam: {
        dictTypeName: '',
        dictTypeCode: '',
        menuName: '',
        menuId: '',
      },
      insertDictType: {
        dictTypeName: '',
        dictTypeCode: '',
        menuName: '',
        menuId: '',
        description: '',
      },
      updateDictType: {
        dictTypeName: '',
        dictTypeCode: '',
        menuName: '',
        menuId: '',
        description: '',
      },
      newdic: false,
      modifyDic: false,
      functionList: [],
      menuData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName',
      },
      pageNo: 1,
      currentPage: 1,
      sumCount: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      dictTypeName: '',
      dictTypeCode: '',
      status: '',
      // 新增字典类别按钮loading标记
      newAddLoadingFlag: false,
      // 修改字典类别按钮loading标记
      newUptLoadingFlag: false,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
    contactPlansInBatches() {
      this.$nextTick(() => this.$refs.plansForm.clearValidate());
    },
  },
  mounted() {
    this.queryMenuList();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.dictTypeQuery);
    },
    // 查询按钮
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 重置按钮
    rest() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 归属菜单数据
    queryMenuList() {
      const parames = {
        data: {},
      };
      return this.$_post(this.$API.menuListByRole, parames).then((res) => {
        this.menuData = res.data.list;
      });
    },
    // 归属菜单下拉数据展示
    renderSearchTreeItem(h, { data }) {
      const className = 'ellipsis';
      if (data.menuName?.length >= 6) {
        return (
          <el-tooltip placement="right" content={data.menuName}>
            <span class={className} style="width: 80px;">
              {data.menuName}
            </span>
          </el-tooltip>
        );
      }
      return <span class={className}>{data.menuName}</span>;
    },
    // 点击归属菜单
    getNodeData(handleName, nodeData) {
      console.log('nodeDatnodeDatanodeDataa', nodeData);
      this[handleName].menuName = nodeData.menuName;
      this[handleName].menuId = nodeData.id;
    },
    // 新增和修改时校验规则
    checkFormData(handleName) {
      function lengthCheck(n) {
        return v => v.length <= n;
      }
      const rules = [
        {
          prop: 'dictTypeName',
          message: '请输入字典类别名称',
          validations: [
            {
              message: '字典类别名称不能超过20个字符',
              validate: lengthCheck(20),
            },
          ],
        },
        {
          prop: 'dictTypeCode',
          message: '请输入字典类别标识',
          validations: [
            {
              message: this.$MSG.M0074,
              validate: lengthCheck(40),
            },
          ],
        },
        {
          prop: 'menuName',
          message: '请选择归属菜单',
        },
        {
          prop: 'description',
          required: false,
          validations: [
            {
              message: '描述不能超过200个字符',
              validate: lengthCheck(200),
            },
          ],
        },
      ];
      return this.validate(rules, this[handleName]);
    },
    // 点击新增
    addInfo() {
      this.newdic = true;
      Object.keys(this.insertDictType).forEach((key) => {
        this.insertDictType[key] = '';
      });
    },

    // 新增校验
    insertDictTypeClick() {
      if (!this.checkFormData('insertDictType')) {
        return;
      }
      this.newAddLoadingFlag = true;
      this.$_yh_confirm(
        '字典类别新增后将无法删除, 确定要新增吗?',
        '新增字典类别',
      ).then(() => {
        const createUserid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
        const params = {
          data: {
            dictTypeName: this.insertDictType.dictTypeName,
            dictTypeCode: this.insertDictType.dictTypeCode,
            description: this.insertDictType.description,
            menuId: this.insertDictType.menuId,
            createUserid,
          },
        };
        this.addDictType(params);
      }).catch(() => {
        this.newAddLoadingFlag = false;
      });
    },
    // 新增确定
    addDictType(params) {
      return this.$_post(this.$API.dictTypeAdd, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.newdic = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.newAddLoadingFlag = false;
      });
    },
    // 点击修改
    modify(row) {
      this.modifyDic = true;
      this.updateDictType = JSON.parse(JSON.stringify(row));
    },
    // 修改校验
    handleUpdateDictTypeClick() {
      if (!this.checkFormData('updateDictType')) {
        return;
      }
      this.newUptLoadingFlag = true;
      this.$_yh_confirm(
        `确认要修改${this.updateDictType.dictTypeCode}的字典类别信息吗？`,
        '修改字典类别',
      ).then(() => {
        const updateUserid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
        const params = {
          data: {
            id: this.updateDictType.id,
            dictTypeName: this.updateDictType.dictTypeName,
            dictTypeCode: this.updateDictType.dictTypeCode,
            description: this.updateDictType.description,
            menuId: this.updateDictType.menuId,
            updateUserid,
          },
        };
        this.updateDict(params);
      }).catch(() => {
        this.newUptLoadingFlag = false;
      });
    },
    // 修改确定
    updateDict(params) {
      return this.$_post(this.$API.dictTypeEdit, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.newUptLoadingFlag = false;
      });
    },
    // 字典项详情
    findDictDetail(row) {
      this.dictTypeName = '';
      this.dictTypeCode = '';
      // sessionStorage.setItem('functionList', JSON.stringify(functionList));
      sessionStorage.setItem('dictTypeDetail', JSON.stringify(row));
      this.addNav({
        name: '字典项列表',
        path: '/sysDicInfo',
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/button.scss";
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.el-row {
  text-align: center;
}
.el-col {
  margin-top: 10px;
}
.productDecoration {
  border-bottom: 1px solid #1e88ff;
  color: #1e88ff;
  cursor: pointer;
}
</style>
